import type { ClampQcInventoryBoxSnapshot } from "./clampQcInventoryBoxApi";

export type ClampQcPostQcDisplay =
  | { kind: "idle"; label: "No carton" }
  | { kind: "open"; filled: number; capacity: number; shortCode: string };

export function resolveClampQcPostQcDisplay(
  inventoryBox: ClampQcInventoryBoxSnapshot | null,
  boxCapacity: number,
): ClampQcPostQcDisplay {
  if (inventoryBox == null || inventoryBox.sealed) {
    return { kind: "idle", label: "No carton" };
  }
  return {
    kind: "open",
    filled: inventoryBox.filledCount,
    capacity: inventoryBox.capacity > 0 ? inventoryBox.capacity : boxCapacity,
    shortCode: inventoryBox.shortCode,
  };
}

export function resolveClampQcInventoryBoxPrinterActions(input: {
  inventoryBox: ClampQcInventoryBoxSnapshot | null;
  inventoryBoxSessionStarted: boolean;
}): {
  showPrintFirstBox: boolean;
  showNextBox: boolean;
  showSeal: boolean;
  showReprint: boolean;
} {
  const openBox = input.inventoryBox != null && !input.inventoryBox.sealed;
  if (openBox) {
    return { showPrintFirstBox: false, showNextBox: false, showSeal: true, showReprint: true };
  }
  if (input.inventoryBoxSessionStarted) {
    return { showPrintFirstBox: false, showNextBox: true, showSeal: false, showReprint: false };
  }
  return { showPrintFirstBox: true, showNextBox: false, showSeal: false, showReprint: false };
}

export function clampQcOpenInventoryBoxQueryKey(buildOrderId: number): readonly ["clamp-qc", "inventory-box", "open", number] {
  return ["clamp-qc", "inventory-box", "open", buildOrderId];
}

export function clampQcInventoryBoxPassedClampsQueryKey(
  hex: string,
  buildOrderId: number,
): readonly ["clamp-qc", "inventory-box", "passed-clamps", string, number] {
  return ["clamp-qc", "inventory-box", "passed-clamps", hex, buildOrderId];
}
